// removed by extract-text-webpack-plugin
module.exports = {"image":"ConfirmationPage__image___lxr30","content":"ConfirmationPage__content___1ly2X","primary-button":"ConfirmationPage__primary-button___VgWhn"};